<div class="info-env" *ngIf="env.showEnv"> Env : {{env.name}}</div>